(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("grapesjs"));
	else if(typeof define === 'function' && define.amd)
		define("grapesjs-components-farmer", ["grapesjs"], factory);
	else if(typeof exports === 'object')
		exports["grapesjs-components-farmer"] = factory(require("grapesjs"));
	else
		root["grapesjs-components-farmer"] = factory(root["grapesjs"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE_grapesjs__) {
return 